import useSWRImmutable from 'swr';

export default function usePOST(path, body, axiosCfg, swrOpts) {
  const method = 'POST';

  let swrKey   = [path, method, body, axiosCfg];
  if (path == null)
    swrKey = null; //sending request conditionally

  return useSWRImmutable(swrKey, swrOpts);
}